import { useState, useEffect } from 'react';
import FadeInSection from '../../../components/feature/FadeInSection';
import { supabase } from '../../../lib/supabaseClient';
import { SuccessCase } from '../../../types/successCase';

export default function SuccessCasesGrid() {
  const [cases, setCases] = useState<SuccessCase[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCases = async () => {
      const { data } = await supabase
        .from('8a4f04ed_success_cases')
        .select('*')
        .eq('published', true)
        .order('sort_order', { ascending: true });
      if (data) setCases(data as SuccessCase[]);
      setLoading(false);
    };
    fetchCases();
  }, []);

  return (
    <section className="section-padding" style={{ background: '#fff8f2' }}>
      <div className="content-width">
        <FadeInSection className="text-center mb-14">
          <p
            className="inline-block px-4 py-1 rounded-full mb-4 text-sm font-bold"
            style={{ background: '#5a9e6f', color: '#fff' }}
          >
            全ての成婚事例
          </p>
          <h2 style={{ color: '#4a3728' }}>喜びの声をご紹介します</h2>
          <p style={{ color: '#6b5a4e', marginTop: '12px', fontSize: '17px' }}>
            「和はは」から生まれた、たくさんの幸せなご縁
          </p>
        </FadeInSection>

        {loading ? (
          <div className="flex items-center justify-center py-20 gap-3" style={{ color: '#9b8b7f' }}>
            <span className="flex items-center justify-center w-5 h-5">
              <i className="ri-loader-4-line text-xl animate-spin" style={{ color: '#5a9e6f' }}></i>
            </span>
            読み込み中...
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {cases.map((item, index) => (
              <FadeInSection key={item.id} delay={index * 80}>
                <article
                  className="bg-white rounded-xl overflow-hidden cursor-default"
                  style={{
                    borderLeft: '4px solid #5a9e6f',
                    transition: 'transform 0.3s, box-shadow 0.3s',
                  }}
                  onMouseEnter={(e) => {
                    (e.currentTarget as HTMLElement).style.transform = 'translateY(-4px)';
                    (e.currentTarget as HTMLElement).style.boxShadow = '0 8px 24px rgba(0,0,0,0.10)';
                  }}
                  onMouseLeave={(e) => {
                    (e.currentTarget as HTMLElement).style.transform = 'translateY(0)';
                    (e.currentTarget as HTMLElement).style.boxShadow = 'none';
                  }}
                >
                  {item.image_url && (
                    <div className="w-full h-[220px] overflow-hidden">
                      <img
                        src={item.image_url}
                        alt={`${item.ages}の成婚事例 - 和はは シニア結婚相談所 東京`}
                        className="w-full h-full object-cover object-top transition-transform duration-500 hover:scale-105"
                        loading="lazy"
                        width={480}
                        height={220}
                      />
                    </div>
                  )}
                  <div className="p-8">
                    <div className="flex items-center gap-3 mb-3">
                      {item.active_period && (
                        <span
                          className="inline-block px-3 py-1 rounded-full text-sm font-bold"
                          style={{ background: '#f2f8f4', color: '#5a9e6f', border: '1px solid #5a9e6f' }}
                        >
                          {item.active_period}
                        </span>
                      )}
                    </div>
                    <h3
                      style={{
                        color: '#8b4513',
                        fontSize: '22px',
                        fontWeight: '700',
                        marginBottom: '12px',
                      }}
                    >
                      {item.ages}
                    </h3>
                    <p style={{ color: '#6b5a4e', lineHeight: '1.9', fontSize: '16px' }}>
                      「{item.excerpt}」
                    </p>
                  </div>
                </article>
              </FadeInSection>
            ))}
          </div>
        )}

        {/* Stats bar */}
        <FadeInSection className="mt-16">
          <div
            className="rounded-2xl p-8 md:p-12 grid grid-cols-1 sm:grid-cols-3 gap-0 divide-y sm:divide-y-0 sm:divide-x divide-[#e8d8cc] text-center"
            style={{ background: '#fff', border: '2px solid #5a9e6f' }}
          >
            <div className="py-6 sm:py-0">
              <p style={{ color: '#5a9e6f', fontSize: '48px', fontWeight: '700', lineHeight: '1' }}>
                98<span style={{ fontSize: '24px' }}>%</span>
              </p>
              <p style={{ color: '#6b5a4e', fontSize: '15px', marginTop: '8px' }}>
                会員満足度
              </p>
            </div>
            <div className="py-6 sm:py-0">
              <p style={{ color: '#e8934e', fontSize: '48px', fontWeight: '700', lineHeight: '1' }}>
                50<span style={{ fontSize: '24px' }}>代〜</span>
              </p>
              <p style={{ color: '#6b5a4e', fontSize: '15px', marginTop: '8px' }}>
                全員シニア専門対応
              </p>
            </div>
            <div className="py-6 sm:py-0">
              <p style={{ color: '#8b4513', fontSize: '48px', fontWeight: '700', lineHeight: '1' }}>
                多数
              </p>
              <p style={{ color: '#6b5a4e', fontSize: '15px', marginTop: '8px' }}>
                60代・70代の成婚実績
              </p>
            </div>
          </div>
        </FadeInSection>
      </div>
    </section>
  );
}